<template>
  <div class="menu-detail-wrap">
    <section v-for="(detail_item, index) in detail_data" :key="index">
      <!-- 容量 / 冷熱 / 甜度 -->
      <div v-if="detail_item.value !== 'add_on'" class="detail-box">
        <div class="title">
          <p>
            <span class="icon"></span>
            {{ detail_item.label }}
          </p>
          <div v-if="detail_item.btns?.length > 4" class="line"></div>
        </div>
        <div v-if="detail_item.btns?.length > 0" class="d-flex-wrap button">
          <cus-button
            v-for="(item, index) in detail_item.btns?.slice(
              0,
              detail_item.btns?.length > max_btns ? max_btns - 1 : max_btns
            )"
            :key="index"
            :text="item.label"
            color="gray-noFocus"
            :width="item.width"
            :selected="checkSelected(detail_item.value, getDetail[detail_item.value], item.value)"
            @click="handleDetailClick(detail_item.value, item)"
            :disabled="!getCanEdit[detail_item.value]"
          ></cus-button>
          <cus-button
            v-if="detail_item.btns?.length > max_btns"
            text="更多"
            :leftIcon="
              checkMore(detail_item.value, detail_item.btns, getDetail[detail_item.value])
                ? 'check-circle-fill'
                : 'plus'
            "
            :leftIconClass="
              checkMore(detail_item.value, detail_item.btns, getDetail[detail_item.value]) ? 'green-icon' : 'more'
            "
            :width="25"
            @click="openDialog(detail_item.dialogName)"
            :disabled="!getCanEdit[detail_item.value]"
          ></cus-button>
        </div>
        <cus-button v-else text="無法選擇" :width="25" :disabled="true"></cus-button>
      </div>

      <!-- 加料 -->
      <div v-else class="detail-box">
        <div class="title">
          <p>
            <span class="icon"></span>
            {{ detail_item.label }}
          </p>
          <div class="line"></div>
        </div>
        <div class="button">
          <div>
            <div v-if="detail_item.btns?.length > 0" class="d-flex-wrap">
              <cus-button
                v-for="(item, index) in detail_item.btns?.slice(
                  0,
                  detail_item.btns?.length > max_btns ? max_btns - 1 : max_btns
                )"
                :key="index"
                :text="item.label"
                :color="item.free_addon && isFreeAddon ? 'whiteYellow' : 'gray-noFocus'"
                :width="item.width"
                :selected="checkSelected(detail_item.value, getDetail[detail_item.value], item.value)"
                @click="handleDetailClick(detail_item.value, item)"
                :disabled="!getCanEdit[detail_item.value]"
              ></cus-button>
            </div>
            <div v-else class="d-flex-wrap">
              <cus-button text="無法選擇" :width="25" :disabled="true"></cus-button>
            </div>
          </div>
          <div class="d-flex">
            <cus-button
              v-if="getDetail[detail_item.value]?.length === 0"
              :text="addOnText"
              :width="75"
              color="white"
              :disabled="true"
            ></cus-button>
            <cus-button
              v-else
              :text="addOnText"
              textClass="add_on-text"
              :width="75"
              color="green-border"
              :disabled="!getCanEdit[detail_item.value] || getDetail[detail_item.value]?.length === 0"
              @click="openDialog('editAddOn')"
            ></cus-button>
            <cus-button
              text="更多"
              leftIcon="plus"
              leftIconClass="add_on-more"
              :width="25"
              color="green-border"
              @click="openDialog(detail_item.dialogName)"
              :disabled="!getCanEdit[detail_item.value] || !getAllAddOnList || getAllAddOnList?.length === 0"
            ></cus-button>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useGetters, useMutations } from '@/utils/mapStore';
import { useDialog } from '@/utils/dialog';
import { ref, computed, reactive, defineAsyncComponent, watch } from 'vue';
export default {
  name: 'menu-detail',
  components: {
    MoreSelect: defineAsyncComponent(() => import('@/components/dialog/MoreSelect.vue')),
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
    EditAddOn: defineAsyncComponent(() => import('@/components/dialog/EditAddOn.vue')),
  },
  setup() {
    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //取得detail所選清單
    const { getDetail, getCanEdit } = useGetters('menuItem', ['getDetail', 'getCanEdit']);
    //設定按鈕
    const getDetailBtns = useGetters('list', ['getDetailBtns']);
    const size_btns = computed(() => addWidth(JSON.parse(JSON.stringify(getDetailBtns.value.size)), 25));
    const temperature_btns = computed(() => addWidth(JSON.parse(JSON.stringify(getDetailBtns.value.temperature)), 25));
    const sweetness_btns = computed(() => addWidth(JSON.parse(JSON.stringify(getDetailBtns.value.sweetness)), 25));
    const add_on_btns = computed(() => addWidth(JSON.parse(JSON.stringify(getDetailBtns.value.add_on)), 15));
    function addWidth(array, width) {
      if (array?.length > 0) {
        array.forEach((el) => (el.width = width));
      }
      return array;
    }
    const max_btns = ref(8);
    //建立不同品項的按鈕清單
    const detail_data = computed(() => {
      const arr = reactive([
        { label: '容量', value: 'size', btns: size_btns, dialogName: 'moreSize' },
        { label: '冷熱', value: 'temperature', btns: temperature_btns, dialogName: 'moreTemperature' },
        { label: '甜度', value: 'sweetness', btns: sweetness_btns, dialogName: 'moreSweetness' },
        { label: '加料', value: 'add_on', btns: add_on_btns, dialogName: 'moreAddOn' },
      ]);
      return arr;
    });

    //處理選項按鈕選中狀態
    const checkSelected = (type, select, input) => {
      if (type !== 'add_on') {
        if (select === input) return true;
      } else {
        if (select?.some((e) => e.value === input)) return true;
      }
      return false;
    };
    //處理更多按鈕選中狀態
    const checkMore = (type, arr, val) => {
      if (type !== 'add_on') {
        const index = arr?.findIndex((e) => e.value === val);
        if (index >= max_btns.value - 1) return true;
      } else {
        let status = false;
        val.forEach((item) => {
          const index = arr?.findIndex((e) => e.value === item);
          if (index >= max_btns.value - 1) status = true;
        });
        return status;
      }
      return false;
    };
    //點擊按鈕
    const { SET_DETAIL, SET_ITEM_PRICE } = useMutations('menuItem', ['SET_DETAIL', 'SET_ITEM_PRICE']);
    const handleDetailClick = (kind, item) => {
      if (kind === 'size') {
        handleSizePrice(item);
      } else if (kind === 'add_on') {
        SET_DETAIL({ kind, value: { ...item, amount: 1 } });
      } else {
        SET_DETAIL({ kind, value: item.value });
      }
    };
    //處理容量按鈕
    const size_value = ref('');
    const handleSizePrice = (item) => {
      switch (item.price_type) {
        case 1:
          SET_ITEM_PRICE(item.select_price[0]);
          SET_DETAIL({ kind: 'size', value: item.value });
          break;
        case 2:
          {
            size_value.value = item.value;
            let list = [];
            item.select_price.forEach((e) => {
              list.push({
                label: `$${e}`,
                value: e,
              });
            });
            openDialog('selectPrice', {}, { dialogTitle: item.label, dialogList: list });
          }
          break;
        case 3:
          size_value.value = item.value;
          openDialog('customPrice');
          break;
      }
    };
    //處理加料按鈕
    const { getAllProducts, getAllProductsAddOn, getAllAddOnList } = useGetters('list', [
      'getAllProducts',
      'getAllProductsAddOn',
      'getAllAddOnList',
    ]);
    const { getItemValue, getItemId, getFreeAddonsAmount } = useGetters('menuItem', [
      'getItemValue',
      'getItemId',
      'getFreeAddonsAmount',
    ]);
    const { SET_ADD_ON_BTNS, SET_ALL_ADD_ON_LIST } = useMutations('list', ['SET_ADD_ON_BTNS', 'SET_ALL_ADD_ON_LIST']);
    const SET_MORE_ADD_ON = useMutations('menuItem', ['SET_MORE_ADD_ON']);
    const isFreeAddon = ref(false);
    //監聽容量value
    watch(
      () => [getDetail.value.size, getItemId.value],
      () => {
        if (getDetail.value.size && getDetail.value.size !== 'no-select') {
          //取得容量對應的預設加料清單
          const { size } = getAllProducts.value[getItemValue.value];
          SET_ADD_ON_BTNS(size.find((e) => e.value === getDetail.value.size)?.add_on);
          //取得容量對應的全部加料清單
          const allAddOnList = getAllProductsAddOn.value[getDetail.value.size];
          SET_ALL_ADD_ON_LIST(allAddOnList);
          //若已有選擇加料，須取得該加料對應容量的正確金額(當有切換容量或選擇購物車內品項時顯示的加料金額才會是正確的)
          if (getDetail.value.add_on.length > 0) {
            const check_arr = getAllAddOnList.value.map((e) => e.value);
            let newList = getDetail.value.add_on;
            getDetail.value.add_on.forEach((e, index) => {
              if (!check_arr.includes(e.value)) newList.splice(index, 1);
              else {
                getAllAddOnList.value.forEach((i) => {
                  if (i.value === e.value) newList[index].price = i.price;
                });
              }
            });
          } else {
            if (getFreeAddonsAmount.value > 0) isFreeAddon.value = true;
          }
        }
      },
      { immediate: true }
    );
    //抓出可以免費加料的選項
    const freeAnnOnData = computed(() => {
      let obj = {};
      if (getDetailBtns.value.add_on.length > 0) {
        getDetailBtns.value.add_on.forEach((e) => {
          if (e.free_addon > 0) {
            obj[e.value] = JSON.parse(JSON.stringify(e));
          }
        });
      }
      return obj;
    });
    //處理加料顯示文字
    const SET_ADD_ONS_CHARGE = useMutations('menuItem', ['SET_ADD_ONS_CHARGE']);
    const addOnText = ref('');
    const getAddOnText = () => {
      //依照加料金額排序(小到大)
      getDetail.value.add_on.sort((a, b) => {
        if (a.price < b.price) return -1;
        else if (a.price === b.price) return 0;
        else if (a.price > b.price) return 1;
      });
      let all_text = []; //加料顯示文字
      let total = getFreeAddonsAmount.value; //該商品可被免費加料的次數
      let totalCharge = 0; //加料金額計算
      getDetail.value.add_on.forEach((e) => {
        //以下加料邏輯與後端相同，以確保前後端計算的金額盡量相同
        if (freeAnnOnData.value[e.value]?.free_addon > 0 && total > 0) {
          const freeAddOnAmount = 3; //該加料可被免費加料的次數
          if (total >= e.amount) {
            if (e.amount > freeAddOnAmount) {
              const chargeAmount = e.amount - freeAddOnAmount;
              const item_text_free = e.label + `(0)` + (freeAddOnAmount > 1 ? `*${freeAddOnAmount}` : '');
              const item_text_charge = e.label + `(${e.price})` + (chargeAmount > 1 ? `*${chargeAmount}` : '');
              all_text.push(item_text_free);
              all_text.push(item_text_charge);
              totalCharge += e.price * chargeAmount;
              total -= freeAddOnAmount;
            } else {
              const item_text = e.label + `(0)` + (e.amount > 1 ? `*${e.amount}` : '');
              all_text.push(item_text);
              total -= e.amount;
            }
          } else {
            if (e.amount > freeAddOnAmount) {
              const freeAmount = Math.min(freeAddOnAmount, total);
              const chargeAmount = e.amount - freeAmount;
              const item_text_free = e.label + `(0)` + (freeAmount > 1 ? `*${freeAmount}` : '');
              const item_text_charge = e.label + `(${e.price})` + (chargeAmount > 1 ? `*${chargeAmount}` : '');
              all_text.push(item_text_free);
              all_text.push(item_text_charge);
              totalCharge += e.price * chargeAmount;
              total -= freeAmount;
            } else {
              const chargeAmount = e.amount - total;
              const item_text_free = e.label + `(0)` + (total > 1 ? `*${total}` : '');
              const item_text_charge = e.label + `(${e.price})` + (chargeAmount > 1 ? `*${chargeAmount}` : '');
              all_text.push(item_text_free);
              all_text.push(item_text_charge);
              totalCharge += e.price * chargeAmount;
              total = 0;
            }
          }
          if (total === 0) isFreeAddon.value = false;
          else isFreeAddon.value = true;
        } else {
          const item_text = e.label + `(${e.price})` + (e.amount > 1 ? `*${e.amount}` : '');
          totalCharge += e.price * e.amount;
          all_text.push(item_text);
        }
      });
      if (getFreeAddonsAmount.value > 0 && total !== 0) isFreeAddon.value = true;
      SET_ADD_ONS_CHARGE(totalCharge);
      addOnText.value = all_text.join(' ') || '尚未選擇加料';
    };
    watch(
      () => getDetail.value.add_on,
      () => {
        getAddOnText();
      },
      { deep: true, immediate: true }
    );
    //處理彈窗動作
    //更多容量
    const handleMoreSize = (val) => {
      SET_DETAIL({ kind: 'size', value: val.value });
      closeDialog();
    };
    //更多冷熱
    const handleMoreTemperature = (val) => {
      SET_DETAIL({ kind: 'temperature', value: val.value });
      closeDialog();
    };
    //更多甜度
    const handleMoreSweetness = (val) => {
      SET_DETAIL({ kind: 'sweetness', value: val.value });
      closeDialog();
    };
    //更多加料
    const handleMoreAddOn = (val) => {
      const selectList = val.map((el) => {
        if (!el.amount) el.amount = 1;
        return el;
      });
      SET_MORE_ADD_ON(selectList);
      closeDialog();
    };
    //編輯加料
    const handleEditAddOn = (val) => {
      SET_MORE_ADD_ON(val);
      closeDialog();
    };
    //容量價格選擇
    const handleSelectPrice = (val) => {
      SET_DETAIL({ kind: 'size', value: size_value.value });
      SET_ITEM_PRICE(val.value);
      closeDialog();
    };
    //自訂容量價格
    const handleCustomPrice = (val) => {
      SET_DETAIL({ kind: 'size', value: size_value.value });
      SET_ITEM_PRICE(val);
      closeDialog();
    };

    return {
      dialogTemplate,
      openDialog,
      max_btns,
      detail_data,
      checkSelected,
      checkMore,
      getDetail,
      getCanEdit,
      SET_DETAIL,
      handleDetailClick,
      getAllAddOnList,
      freeAnnOnData,
      isFreeAddon,
      addOnText,
      handleMoreSize,
      handleMoreTemperature,
      handleMoreSweetness,
      handleMoreAddOn,
      handleEditAddOn,
      handleSelectPrice,
      handleCustomPrice,
    };
  },
};
</script>
<style lang="scss" scoped>
.menu-detail-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 0 15px;
}
$title-wrap: 12%;
.detail-box {
  display: flex;
  align-items: baseline;
  :deep(.more) {
    -webkit-text-stroke: 0.8px $color-text;
  }
  :deep(.add_on-more) {
    -webkit-text-stroke: 0.8px $color-green;
    color: $color-green;
  }
  :deep(.add_on-text) {
    -webkit-line-clamp: 1;
  }
  .title {
    width: $title-wrap;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    color: $color-blue;
    font-size: 2rem;
    @include icon-line;
  }
  .button {
    width: calc(100% - $title-wrap);
  }
}
</style>
